// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
}
.user_outer_main_container {
  border: 1px solid black;
  height: auto;
  width: 100%;
}
.employee-details-form {
  /* max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(
    to bottom,
    rgba(193, 223, 196, 0) 0%,
    rgba(222, 236, 221, 0.9647) 100%
  );
  border-radius: 25px; */

  padding: 32px;
  /* border: 1px solid rgb(189, 188, 188); */
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(
    to bottom,
    rgba(193, 223, 196, 0) 0%,
    rgba(222, 236, 221, 0.9647) 100%
  );
  border-radius: 25px;
  width: 100%;
  /* max-width: 800px; */
  margin: 10px;
  height: 373px;
  overflow-y: scroll;
}

.employee-details-form::-webkit-scrollbar {
  width: 2px;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.input_group {
  margin-bottom: 12px;
}
.input_group input {
  height: 39px;
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Karla", sans-serif;
}
.input_group input[type="date"] {
  margin-top: 0px;
  height: 39px;
}
.input_group label {
  display: block;
  margin-bottom: 0px;
  color: #555;
  height: 22px;
}
.input_group_lable{
  display: flex;

  height: 39px;
  width: 100%;
  padding: 0.5rem;
  /* border: 1px solid #ccc; */
  /* border-radius: 4px; */
  /* font-family: "Karla", sans-serif; */
}
.input_group_lable label{
  width: 90%;
}
.user_section_row {
  display: flex;
  justify-content: space-between; /* Space out child elements */
  margin-top: -4px;
}
.user_section_row_checkBox {
  display: flex;
  justify-content: space-between; /* Space out child elements */
  margin-top: 4px;
}
/* .company-checkboxes {
  max-height: 120px;
  overflow-y: auto;
  margin-top: 8px;
  padding-right: 8px;
} */
 .company-checkboxes-heading{
  font-weight: 700;
  font-size: 18px;

 }
.user_section_row .input_group {
  flex: 1 1; /* Make each input take equal space */
  margin-right: 10px; /* Add right margin to create space between inputs */
}

.user_section_row .form-group:last-child {
  margin-right: 0; /* Remove margin for the last child */
}

.input_group select {
  /* padding: 11px; */
  margin-top: 0px;
  height: 39px;
  border: 1px solid black;
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.input_group [type="text"],
.input_group [type="number"],
.input_group [type="email"] {
  padding: 11px;
  margin-top: 0px;
}
.navigation-buttons {
  /* border: 1px solid black; */
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  gap: 70px;
}
.navigation-buttons button {
  /* border: 1px solid black;  */
  height: 37px;
  width: 78px;
  padding: 8px 2px;
  /* border: 1px solid rgb(200, 200, 200); */
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);

  border-radius: 5px;
  /* width: auto; */
  margin-top: -2px;
}
.user-tracket-main {
  width: 100%;
  display: flex;
  
}
.employee-form {
  width: 100%;
  overflow-y: auto;
}

.employee-form::-webkit-scrollbar {
  width: 2px;
}
.new-user-tracker-details {
  /* border: 1px solid rgb(202, 196, 196); */
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(
    to bottom,
    rgba(201, 222, 203, 0) 0%,
    rgba(222, 236, 221, 0.9647) 100%
  );
  width: 30%;
  height: 377px;
  border-radius: 25px;
  margin: 10px;
}
.new-user-tracker-data {
  position: relative;
  height: 310px;
  width: 265px;
}
.new-user-tracker-data li {
  display: flex;
  font-size: small;
  margin: 13px;
  height: 26px;
  width: 200px;
  margin-left: 40px;
}
.new-user-input-radio {
  /* position: absolute;  */
  width: 7%;
  position: relative;
  z-index: 2;
}
.new-user-lable-details {
  font-size: 14px;
  margin-left: 16px;
  margin-top: 5px;
}

.radio-valid {
  border: 2px solid green;
}
.radio-invalid {
  border: 2px solid red;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
  background-color: white;
  cursor: pointer;
  left: 870px;
  top: 145px;
  z-index: 100;
  width: 500px;
  border-radius: 4px;
  height: 100px;
  overflow-y: scroll;
}

.options {
  margin: 2px 4px;
  border-radius: 4px;
}

.options:hover {
  background-color: #e6e9e8;
}

.highlighted_star {
  color: red;
  /* font-size: 20px; */
  /* margin-top: 1%; */
}

.border_red {
  accent-color: rgb(214, 25, 25);
  border: red;
}

.border_green {
  accent-color: rgb(66, 152, 66);
  border: green;
}

.employee_status {
  padding: 10px;
}
.update-button {
  font-size: 0.7rem;
}

/* Add to NewUserSection.css */
.scrollable-form {
  max-height: 80vh;
  overflow-y: auto;
  padding-right: 10px;
}
.readonly-section {
  margin-bottom: 32px;
  border-bottom: 1px solid #eee;
  padding-bottom: 24px;
}

.back_button_navigate {
  height: 24px;
  width: 100%;
  /* border: 1px solid black; */
  font-size: 23px;
  color: gray;
  cursor: pointer;
}

.back_button_navigate button {
  cursor: pointer;
  padding: 1px 12px;
  font-size: 21px;
  /* background-color: #7f8c8d; */
  /* color: white; */
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease;
}
.back_button_navigate button:hover {
  background-color: #c6d4ca;
}

/* Vertical line */
.new-user-tracker-details ul {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}

.new-user-tracker-details li {
  position: relative;
  padding-left: 30px; /* space for radio and line */
  /* margin-bottom: 40px; spacing between items */
}
.new-user-tracker-details li::before {
  content: "";
  position: absolute;
  top: 22px;
  left: 35px;
  width: 1px;
  height: 78%;
  background-color: #ccc;
  z-index: 0;
}

/* Remove line on last item */
.new-user-tracker-details li:last-child::before {
  height: 0px;
}

/* ===================== Responsive Design ===================== */

/* ========== Mobile-first Base (default) ========== */

@media (max-width: 767px) {
  .user-tracket-main {
    flex-direction: column;
  }

  .employee-form {
    overflow-y: auto;
    max-height: 80vh;
    padding-right: 10px;
  }

  .employee-details-form {
    height: auto;
    overflow-y: visible;
    padding: 12px;
    margin: 10px;
  }

  .user_section_row {
    flex-direction: column;
    gap: 10px;
  }

  .input_group {
    width: 100%;
    margin-right: 0;
  }

  .input_group input,
  .input_group select {
    width: 100%;
    font-size: 14px;
    padding: 10px;
  }

  .navigation-buttons {
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
  }

  .navigation-buttons button {
    width: 90%;
    max-width: 300px;
  }

  .back_button_navigate button {
    font-size: 18px;
  }

  .new-user-tracker-details {
    display: none;
  }

  .absolute {
    position: static;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ccc;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }
}

/* Tablet */
@media (min-width: 768px) and (max-width: 1024px) {
  .user_section_row {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .user_section_row .input_group {
    width: 48%;
    margin-bottom: 12px;
  }

  .new-user-tracker-details {
    width: 33%;
    border-radius: 25px;
  }

  .new-user-tracker-data {
    width: 100%;
    height: auto;
  }

  .new-user-tracker-data li {
    font-size: 0.95rem;
    margin-left: 30px;
  }

  .absolute {
    width: 70%;
    left: 15%;
  }

  .navigation-buttons {
    gap: 30px;
  }

  .navigation-buttons button {
    width: 120px;
  }
  .new-user-lable-details {
    font-size: 9px;
    margin-left: 11px;
    margin-top: 5px;
  }
}

/* Desktop */
@media (min-width: 1025px) {
  .user_section_row {
    flex-direction: row;
  }

  .new-user-tracker-details {
    width: 30%;
  }

  .new-user-tracker-data {
    width: 265px;
  }

  .new-user-tracker-data li {
    font-size: small;
    margin-left: 40px;
  }

  .absolute {
    width: 500px;
    left: 870px;
  }

  .navigation-buttons {
    flex-direction: row;
    gap: 70px;
  }

  .navigation-buttons button {
    width: 78px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/NewUserComponent/NewUserSection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;AACA;EACE;;;;;;;;;;;wBAWsB;;EAEtB,aAAa;EACb,0CAA0C;EAC1C,sCAAsC;EACtC;;;;GAIC;EACD,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;;EAEb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;AACxC;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,8BAA8B,EAAE,6BAA6B;EAC7D,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B,EAAE,6BAA6B;EAC7D,eAAe;AACjB;AACA;;;;;GAKG;CACF;EACC,gBAAgB;EAChB,eAAe;;CAEhB;AACD;EACE,SAAO,EAAE,qCAAqC;EAC9C,kBAAkB,EAAE,oDAAoD;AAC1E;;AAEA;EACE,eAAe,EAAE,qCAAqC;AACxD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;;;EAGE,aAAa;EACb,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,sCAAsC;;EAEtC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;;AAEf;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC;;;;GAIC;EACD,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB,EAAE,6BAA6B;EACjD,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA,kEAAkE;;AAElE,sDAAsD;;AAEtD;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,sCAAsC;EACxC;AACF;;AAEA,WAAW;AACX;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n}\n.user_outer_main_container {\n  border: 1px solid black;\n  height: auto;\n  width: 100%;\n}\n.employee-details-form {\n  /* max-width: 600px;\n  margin: 20px auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(\n    to bottom,\n    rgba(193, 223, 196, 0) 0%,\n    rgba(222, 236, 221, 0.9647) 100%\n  );\n  border-radius: 25px; */\n\n  padding: 32px;\n  /* border: 1px solid rgb(189, 188, 188); */\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(\n    to bottom,\n    rgba(193, 223, 196, 0) 0%,\n    rgba(222, 236, 221, 0.9647) 100%\n  );\n  border-radius: 25px;\n  width: 100%;\n  /* max-width: 800px; */\n  margin: 10px;\n  height: 373px;\n  overflow-y: scroll;\n}\n\n.employee-details-form::-webkit-scrollbar {\n  width: 2px;\n}\n\nh2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.input_group {\n  margin-bottom: 12px;\n}\n.input_group input {\n  height: 39px;\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: \"Karla\", sans-serif;\n}\n.input_group input[type=\"date\"] {\n  margin-top: 0px;\n  height: 39px;\n}\n.input_group label {\n  display: block;\n  margin-bottom: 0px;\n  color: #555;\n  height: 22px;\n}\n.input_group_lable{\n  display: flex;\n\n  height: 39px;\n  width: 100%;\n  padding: 0.5rem;\n  /* border: 1px solid #ccc; */\n  /* border-radius: 4px; */\n  /* font-family: \"Karla\", sans-serif; */\n}\n.input_group_lable label{\n  width: 90%;\n}\n.user_section_row {\n  display: flex;\n  justify-content: space-between; /* Space out child elements */\n  margin-top: -4px;\n}\n.user_section_row_checkBox {\n  display: flex;\n  justify-content: space-between; /* Space out child elements */\n  margin-top: 4px;\n}\n/* .company-checkboxes {\n  max-height: 120px;\n  overflow-y: auto;\n  margin-top: 8px;\n  padding-right: 8px;\n} */\n .company-checkboxes-heading{\n  font-weight: 700;\n  font-size: 18px;\n\n }\n.user_section_row .input_group {\n  flex: 1; /* Make each input take equal space */\n  margin-right: 10px; /* Add right margin to create space between inputs */\n}\n\n.user_section_row .form-group:last-child {\n  margin-right: 0; /* Remove margin for the last child */\n}\n\n.input_group select {\n  /* padding: 11px; */\n  margin-top: 0px;\n  height: 39px;\n  border: 1px solid black;\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.input_group [type=\"text\"],\n.input_group [type=\"number\"],\n.input_group [type=\"email\"] {\n  padding: 11px;\n  margin-top: 0px;\n}\n.navigation-buttons {\n  /* border: 1px solid black; */\n  width: 100%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  gap: 70px;\n}\n.navigation-buttons button {\n  /* border: 1px solid black;  */\n  height: 37px;\n  width: 78px;\n  padding: 8px 2px;\n  /* border: 1px solid rgb(200, 200, 200); */\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n\n  border-radius: 5px;\n  /* width: auto; */\n  margin-top: -2px;\n}\n.user-tracket-main {\n  width: 100%;\n  display: flex;\n  \n}\n.employee-form {\n  width: 100%;\n  overflow-y: auto;\n}\n\n.employee-form::-webkit-scrollbar {\n  width: 2px;\n}\n.new-user-tracker-details {\n  /* border: 1px solid rgb(202, 196, 196); */\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(\n    to bottom,\n    rgba(201, 222, 203, 0) 0%,\n    rgba(222, 236, 221, 0.9647) 100%\n  );\n  width: 30%;\n  height: 377px;\n  border-radius: 25px;\n  margin: 10px;\n}\n.new-user-tracker-data {\n  position: relative;\n  height: 310px;\n  width: 265px;\n}\n.new-user-tracker-data li {\n  display: flex;\n  font-size: small;\n  margin: 13px;\n  height: 26px;\n  width: 200px;\n  margin-left: 40px;\n}\n.new-user-input-radio {\n  /* position: absolute;  */\n  width: 7%;\n  position: relative;\n  z-index: 2;\n}\n.new-user-lable-details {\n  font-size: 14px;\n  margin-left: 16px;\n  margin-top: 5px;\n}\n\n.radio-valid {\n  border: 2px solid green;\n}\n.radio-invalid {\n  border: 2px solid red;\n}\n\n.relative {\n  position: relative;\n}\n\n.absolute {\n  position: absolute;\n  background-color: white;\n  cursor: pointer;\n  left: 870px;\n  top: 145px;\n  z-index: 100;\n  width: 500px;\n  border-radius: 4px;\n  height: 100px;\n  overflow-y: scroll;\n}\n\n.options {\n  margin: 2px 4px;\n  border-radius: 4px;\n}\n\n.options:hover {\n  background-color: #e6e9e8;\n}\n\n.highlighted_star {\n  color: red;\n  /* font-size: 20px; */\n  /* margin-top: 1%; */\n}\n\n.border_red {\n  accent-color: rgb(214, 25, 25);\n  border: red;\n}\n\n.border_green {\n  accent-color: rgb(66, 152, 66);\n  border: green;\n}\n\n.employee_status {\n  padding: 10px;\n}\n.update-button {\n  font-size: 0.7rem;\n}\n\n/* Add to NewUserSection.css */\n.scrollable-form {\n  max-height: 80vh;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n.readonly-section {\n  margin-bottom: 32px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 24px;\n}\n\n.back_button_navigate {\n  height: 24px;\n  width: 100%;\n  /* border: 1px solid black; */\n  font-size: 23px;\n  color: gray;\n  cursor: pointer;\n}\n\n.back_button_navigate button {\n  cursor: pointer;\n  padding: 1px 12px;\n  font-size: 21px;\n  /* background-color: #7f8c8d; */\n  /* color: white; */\n  border: none;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.back_button_navigate button:hover {\n  background-color: #c6d4ca;\n}\n\n/* Vertical line */\n.new-user-tracker-details ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  position: relative;\n}\n\n.new-user-tracker-details li {\n  position: relative;\n  padding-left: 30px; /* space for radio and line */\n  /* margin-bottom: 40px; spacing between items */\n}\n.new-user-tracker-details li::before {\n  content: \"\";\n  position: absolute;\n  top: 22px;\n  left: 35px;\n  width: 1px;\n  height: 78%;\n  background-color: #ccc;\n  z-index: 0;\n}\n\n/* Remove line on last item */\n.new-user-tracker-details li:last-child::before {\n  height: 0px;\n}\n\n/* ===================== Responsive Design ===================== */\n\n/* ========== Mobile-first Base (default) ========== */\n\n@media (max-width: 767px) {\n  .user-tracket-main {\n    flex-direction: column;\n  }\n\n  .employee-form {\n    overflow-y: auto;\n    max-height: 80vh;\n    padding-right: 10px;\n  }\n\n  .employee-details-form {\n    height: auto;\n    overflow-y: visible;\n    padding: 12px;\n    margin: 10px;\n  }\n\n  .user_section_row {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .input_group {\n    width: 100%;\n    margin-right: 0;\n  }\n\n  .input_group input,\n  .input_group select {\n    width: 100%;\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .navigation-buttons {\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    margin-top: 12px;\n  }\n\n  .navigation-buttons button {\n    width: 90%;\n    max-width: 300px;\n  }\n\n  .back_button_navigate button {\n    font-size: 18px;\n  }\n\n  .new-user-tracker-details {\n    display: none;\n  }\n\n  .absolute {\n    position: static;\n    width: 100%;\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n  }\n}\n\n/* Tablet */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .user_section_row {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .user_section_row .input_group {\n    width: 48%;\n    margin-bottom: 12px;\n  }\n\n  .new-user-tracker-details {\n    width: 33%;\n    border-radius: 25px;\n  }\n\n  .new-user-tracker-data {\n    width: 100%;\n    height: auto;\n  }\n\n  .new-user-tracker-data li {\n    font-size: 0.95rem;\n    margin-left: 30px;\n  }\n\n  .absolute {\n    width: 70%;\n    left: 15%;\n  }\n\n  .navigation-buttons {\n    gap: 30px;\n  }\n\n  .navigation-buttons button {\n    width: 120px;\n  }\n  .new-user-lable-details {\n    font-size: 9px;\n    margin-left: 11px;\n    margin-top: 5px;\n  }\n}\n\n/* Desktop */\n@media (min-width: 1025px) {\n  .user_section_row {\n    flex-direction: row;\n  }\n\n  .new-user-tracker-details {\n    width: 30%;\n  }\n\n  .new-user-tracker-data {\n    width: 265px;\n  }\n\n  .new-user-tracker-data li {\n    font-size: small;\n    margin-left: 40px;\n  }\n\n  .absolute {\n    width: 500px;\n    left: 870px;\n  }\n\n  .navigation-buttons {\n    flex-direction: row;\n    gap: 70px;\n  }\n\n  .navigation-buttons button {\n    width: 78px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
